import { useEffect, useState } from 'react';

/**
 * Re-renders the component every `intervalMS` milliseconds.
 *
 * It is useful for components that need to re-render periodically.
 * And don't have any reason to re-render.
 */
function useRerenderOnInterval(intervalMS: number) {
  const [_, rerender] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      rerender((prev) => prev + 1);
    }, intervalMS);

    return () => {
      clearInterval(intervalId);
    };
  }, [intervalMS]);
}

export { useRerenderOnInterval };
